import { render, staticRenderFns } from "./SubBottomBar.vue?vue&type=template&id=35b44b56&scoped=true&"
import script from "./SubBottomBar.vue?vue&type=script&lang=js&"
export * from "./SubBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./SubBottomBar.vue?vue&type=style&index=0&id=35b44b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b44b56",
  null
  
)

export default component.exports